module.exports = __webpack_public_path__ + "static/img/8_western_eastern_japan.bb71df8a.png";